import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('posts');
export const TWEET_URI_PREFIX = checkIsStoryBookPath('posts/twitter');
export const apiRoutes = {
  //instagram table
  instagramTable: `${URI_PREFIX}/instagram/all`,
  instagramAutocomplete: `${URI_PREFIX}/instagram/all`,
  instagramPostCodeAutocomplete: `${URI_PREFIX}/instagram/all/post-code`,
  incompleteTable: `${URI_PREFIX}/instagram/incomplete`,
  instagramInfluencersAutocomplete: `${URI_PREFIX}/instagram/influencers`,
  instagramPostsMediaType: `${URI_PREFIX}/instagram/post/media/types`,
  incompletePostCodeAutocomplete: `${URI_PREFIX}/instagram/incomplete/post-code`,
  deleteIncompletePosts: `${URI_PREFIX}/instagram/delete`,
  //instagram Details
  instagramDetails: `${URI_PREFIX}/instagram/post/show`,
  instagramTopMentionUsers: `${URI_PREFIX}/instagram/post/mentioned/profiles`,
  instagramFrequentUsedHashtags: `${URI_PREFIX}/instagram/post/hashtags`,
  instagramFrequentWords: `${URI_PREFIX}/instagram/post/frequent-words`,
  instagramTaggedProfiles: `${URI_PREFIX}/instagram/post/tagged/profiles`,
  instagramCoAuthoredProfiles: `${URI_PREFIX}/instagram/post/co-authored/profiles`,
  instagramCommentSentimentAnalysis: `${URI_PREFIX}/instagram/post/comments/sentiment-analysis/count`,
  instagramMediaClassification: `${URI_PREFIX}/instagram/post/media/classifications/count`,
  instagramMentionedUsers: `${URI_PREFIX}/instagram/post/mentioned/profiles`,
  instagramLogs: `${URI_PREFIX}/instagram/post`,
  instagramRegrabPosts: `${URI_PREFIX}/instagram/regrab`,
  instagramRegrabPostComments: `${URI_PREFIX}/instagram/post/comments/regrab`,
  instagramPostCommentsTab: `${URI_PREFIX}/instagram/post/comments`,
  regrabRepliesConversation: `${URI_PREFIX}/instagram/post/comment/replies/regrab`,
  commentsSorting: `${URI_PREFIX}/instagram/post/comments/sorting`,
  changeCommentsCategories: `${URI_PREFIX}/instagram/post/sentiment-analysis/comment/change-category`,
  //Sentiment analysis
  instagramSentimentAnalysisAdd: `${URI_PREFIX}/instagram/post/sentiment-analysis/words/add`,
  instagramUpdateSentimentAnalysis: `${URI_PREFIX}/instagram/post/sentiment-analysis/data/update`,
  instagramShowSentiment: `${URI_PREFIX}/instagram/post/sentiment-analysis/data/show`,
  hashtagAutocompleteSentiment: `${URI_PREFIX}/instagram/post/hashtags`,
  setsAutocompleteSentiment: `${URI_PREFIX}/instagram/sets`,
  mostFrequentWords: `${URI_PREFIX}/instagram/post/sentiment-analysis/frequent-words`,
  mostFrequentHashtags: `${URI_PREFIX}/instagram/post/sentiment-analysis/frequent-hashtags`,

  commentsList: `${URI_PREFIX}/instagram/post/conversation/show`,
  //Add New Post
  storeInstagramPost: `${URI_PREFIX}/instagram/post/store`,
  //Tiktok Table
  tiktokTable: `${URI_PREFIX}/tiktok/all`,
  tiktokAutocomplete: `${URI_PREFIX}/tiktok/all`,
  tiktokPostIdAutocomplete: `${URI_PREFIX}/tiktok/all/remote-id`,
  tiktokIncompleteTable: `${URI_PREFIX}/tiktok/incomplete`,
  tiktokInfluencersAutocomplete: `${URI_PREFIX}/tiktok/influencers`,
  tiktokPostsMediaType: `${URI_PREFIX}/tiktok/post/media/types`,
  tiktokIncompletePostCodeAutocomplete: `${URI_PREFIX}/tiktok/incomplete/remote-id`,
  tiktokDeleteIncompletePosts: `${URI_PREFIX}/tiktok/delete`,
  tiktokRegrabPosts: `${URI_PREFIX}/tiktok/regrab`,
  tiktokTrendingRegrabPosts: `${URI_PREFIX}/tiktok/trending/regrab`,
  tiktokAddPost: `${URI_PREFIX}/tiktok/post/store`,
  tiktokTrendingTable: `${URI_PREFIX}/tiktok/trending`,
  tiktokTrendingAutocomplete: `${URI_PREFIX}/tiktok/trending`,
  tiktokTrendingPostIdAutocomplete: `${URI_PREFIX}/tiktok/trending/remote-id`,

  //Tiktok Post Details
  tiktokDetails: `${URI_PREFIX}/tiktok/post/show`,
  tiktokTopMentionUsers: `${URI_PREFIX}/tiktok/post/mentioned/profiles`,
  tiktokFrequentUsedHashtags: `${URI_PREFIX}/tiktok/post/hashtags`,
  tiktokTrendingList: `${URI_PREFIX}/tiktok/post/trending/countries`,
  tiktokFrequentWords: `${URI_PREFIX}/tiktok/post/frequent-words`,
  tiktokTaggedProfiles: `${URI_PREFIX}/tiktok/post/tagged/profiles`,
  tiktokCoAuthoredProfiles: `${URI_PREFIX}/tiktok/post/co-authored/profiles`,
  tiktokCommentSentimentAnalysis: `${URI_PREFIX}/tiktok/post/comments/sentiment-analysis/count`,
  tiktokMediaClassification: `${URI_PREFIX}/tiktok/post/media/classifications/count`,
  tiktokMentionedUsers: `${URI_PREFIX}/tiktok/post/mentioned/profiles`,
  tiktokLogs: `${URI_PREFIX}/tiktok/post`,
  tiktokRegrabPostComments: `${URI_PREFIX}/tiktok/post/comments/regrab`,
  tiktokPostCommentsTab: `${URI_PREFIX}/tiktok/post/comments`,
  tiktokRegrabRepliesConversation: `${URI_PREFIX}/tiktok/post/comment/replies/regrab`,
  tiktokCommentsSorting: `${URI_PREFIX}/tiktok/post/comments/sorting`,
  tiktokChangeCommentsCategories: `${URI_PREFIX}/tiktok/post/sentiment-analysis/comment/change-category`,
  tiktokSentimentAnalysisAdd: `${URI_PREFIX}/tiktok/post/sentiment-analysis/words/add`,
  tiktokCommentsList: `${URI_PREFIX}/tiktok/post/conversation/show`,

  //Sentiment analysis
  tiktokUpdateSentimentAnalysis: `${URI_PREFIX}/tiktok/post/sentiment-analysis/data/update`,
  tiktokShowSentiment: `${URI_PREFIX}/tiktok/post/sentiment-analysis/data/show`,
  tiktokHashtagAutocompleteSentiment: `${URI_PREFIX}/tiktok/post/hashtags`,
  tiktokSetsAutocompleteSentiment: `${URI_PREFIX}/tiktok/sets`,
  tiktokMostFrequentWords: `${URI_PREFIX}/tiktok/post/sentiment-analysis/frequent-words`,
  tiktokMostFrequentHashtags: `${URI_PREFIX}/tiktok/post/sentiment-analysis/frequent-hashtags`,
  //twitter table
  allTweets: `${TWEET_URI_PREFIX}/all`,
  allTweetsAutocomplete: `${TWEET_URI_PREFIX}`,
  hashtagsAutocomplete: `${TWEET_URI_PREFIX}/tweet/hashtags`,
  hashtagsTweetsAutocomplete: `${TWEET_URI_PREFIX}/hashtags`,
  tweetIdsAutocomplete: `${TWEET_URI_PREFIX}/remote-ids`,
  influencersAutocomplete: `${TWEET_URI_PREFIX}/influencers`,
  incompleteTweets: `${TWEET_URI_PREFIX}/incomplete`,
  deleteTweet: `${TWEET_URI_PREFIX}/delete`,
  regrabTweet: `${TWEET_URI_PREFIX}/regrab`,
  regrabTweetReplies: `${TWEET_URI_PREFIX}/tweet/replies/regrab`,
  regrabTweetRepliesConversations: `${TWEET_URI_PREFIX}/tweet/reply/conversations/regrab`,
  tweetInCompleteIdsAutocomplete: `${TWEET_URI_PREFIX}/incomplete/remote-ids`,
  tweetTypes: `${TWEET_URI_PREFIX}/types`,

  // TwitterPostDetails
  tweetDetails: `${TWEET_URI_PREFIX}/tweet/show`,
  tweetRepliesSentiment: `${TWEET_URI_PREFIX}/tweet/replies/sentiment-analysis/count`,
  tweetQuotesSentiment: `${TWEET_URI_PREFIX}/tweet/quotes/sentiment-analysis/count`,
  tweetTopWords: `${TWEET_URI_PREFIX}/tweet/frequent-words`,
  tweetFrequentHashtags: `${TWEET_URI_PREFIX}/tweet/frequent-hashtags`,
  tweetHashTags: `${TWEET_URI_PREFIX}/tweet/hashtags`,
  tweetReplies: `${TWEET_URI_PREFIX}/tweet/replies`,
  tweetQuotes: `${TWEET_URI_PREFIX}/tweet/quotes`,
  changeTweetQuotes: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/quote/change-category`,
  tweetReplayConversation: `${TWEET_URI_PREFIX}/tweet/reply/conversations`,
  twitterMostFrequentWords: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/frequent-words`,
  twitterMostFrequentHashtags: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/frequent-hashtags`,
  showTweetSentiment: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/data/show`,
  updateTweetSentiment: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/data/update`,
  tweetHashtagsAutocomplete: `${TWEET_URI_PREFIX}/tweet/hashtags`,
  tweetSetsAutocomplete: `${TWEET_URI_PREFIX}/sets`,
  tweetSentimentAnalysisAdd: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/words/add`,
  changeTweetReplies: `${TWEET_URI_PREFIX}/tweet/sentiment-analysis/reply/change-category`,
  twitterLogs: `${TWEET_URI_PREFIX}/tweet`,
  addTwitterPost: `${TWEET_URI_PREFIX}/tweet/store`,

  //Linkedin
  linkedinTableAllTab: `${URI_PREFIX}/linkedin/all`,
  linkedinRegrabPosts: `${URI_PREFIX}/linkedin/regrab`,
  linkedinTableIncompleteTab: `${URI_PREFIX}/linkedin/incomplete`,
  deletePost: `${URI_PREFIX}/linkedin/delete`,
  linkedinDetails: `${URI_PREFIX}/linkedin/post/show`,
  linkedinCommentSentimentAnalysis: `${URI_PREFIX}/linkedin/post/comments/sentiment-analysis/count`,
  linkedinFrequentUsedWords: `${URI_PREFIX}/linkedin/post/frequent-words`,
  linkedinFrequentUsedHashtags: `${URI_PREFIX}/linkedin/post/hashtags`,

  //Youtube
  //Youtube table

  tableVideosTab: `${URI_PREFIX}/youtube`,
  tableTrendingTab: `${URI_PREFIX}/youtube/trending`,
  tableIncompleteTab: `${URI_PREFIX}/youtube/incomplete`,
  addClientVideos: `${URI_PREFIX}/youtube/add-to-client-videos`,

  videosTabVideosAutoComplete: `${URI_PREFIX}/youtube/all`,
  videosTabHashtagAutoComplete: `${URI_PREFIX}/youtube/hashtags/all`,
  videosInfluencersAutocomplete: `${TWEET_URI_PREFIX}/influencers`,
  youtubeRemoteId: `${URI_PREFIX}/youtube/remote-id`,
  // trending tab autocomplete
  trendingTabVideosAutoComplete: `${URI_PREFIX}/youtube/trending`,
  trendingTabHashtagsAutoComplete: `${URI_PREFIX}/youtube/hashtags/trending`,
  trendingYoutubeRegrabPosts: `${URI_PREFIX}/youtube/trending/regrab`,

  // incomplete tab autocomplete
  incompleteTabAutocomplete: `${URI_PREFIX}/youtube/incomplete`,
  youtubeIncompleteRemoteId: `${URI_PREFIX}/youtube/incomplete/remote-id`,

  //youtube details
  youtubeDetails: `${URI_PREFIX}/youtube/show`,
  youtubeLogs: `${URI_PREFIX}/youtube`,
  youtubeRegrabPostComments: `${URI_PREFIX}/youtube/video/comments/regrab`,
  youtubePostCommentsTab: `${URI_PREFIX}/youtube/video/comments`,
  youtubeRegrabRepliesConversation: `${URI_PREFIX}/youtube/video/comment/replies/regrab`,
  youtubeCommentsSorting: `${URI_PREFIX}/youtube/video/comments/sorting`,
  youtubeChangeCommentsCategories: `${URI_PREFIX}/youtube/video/sentiment-analysis/comment/change-category`,
  youtubeSentimentAnalysisAdd: `${URI_PREFIX}/youtube/video/sentiment-analysis/words/add`,
  youtubeCommentsList: `${URI_PREFIX}/youtube/post/conversation/show`,
  youtubeFrequentUsedHashtags: `${URI_PREFIX}/youtube/video/hashtags`,
  youtubeSentimentComments: `${URI_PREFIX}/youtube/video/comments/sentiment-analysis/count`,
  youtubeFrequentWords: `${URI_PREFIX}/youtube/video/frequent-words`,
  youtubeInfluencersAutocomplete: `${URI_PREFIX}/youtube/influencers`,
  youtubeRelatedTags: `${URI_PREFIX}/youtube/video/tags`,
  youtubeTrendingList: `${URI_PREFIX}/youtube/trending/list-chart`,
  youtubeLastGrabbedOn: `${URI_PREFIX}/youtube/trending/last-grabbed-on`,
  channelSubscribers: `${URI_PREFIX}/youtube/channel/chart/gained-subscribers`,
  channelViews: `${URI_PREFIX}/youtube/channel/chart/views`,
  channelActivities: `${URI_PREFIX}/youtube/channel/chart/activities`,
  uploadedVideos: `${URI_PREFIX}/youtube/channel/chart/uploaded-videos`,
  addVideo: `${URI_PREFIX}/youtube/store`,
  // youtube sentiment
  youtubeUpdateSentimentAnalysis: `${URI_PREFIX}/youtube/video/sentiment-analysis/data/update`,
  youtubeShowSentiment: `${URI_PREFIX}/youtube/video/sentiment-analysis/data/show`,
  youtubeHashtagAutocompleteSentiment: `${URI_PREFIX}/youtube/video/hashtags`,
  youtubeSetsAutocompleteSentiment: `${URI_PREFIX}/youtube/sets`,
  youtubeMostFrequentWords: `${URI_PREFIX}/youtube/video/sentiment-analysis/frequent-words`,
  youtubeMostFrequentHashtags: `${URI_PREFIX}/youtube/video/sentiment-analysis/frequent-hashtags`,
  //inline actions
  trashVideo: `${URI_PREFIX}/youtube/trash`,
  deleteVideo: `${URI_PREFIX}/youtube/delete`,
  regrabVideo: `${URI_PREFIX}/youtube/resync`,
  restoreVideo: `${URI_PREFIX}/youtube/restore`,
  unnecessaryVideo: `${URI_PREFIX}/youtube/unnecessary`,
  hideVideo: `${URI_PREFIX}/youtube/trash-or-unnecessary`,

  linkedinRegrabPostComments: `${URI_PREFIX}/linkedin/post/comments/regrab`,
  storeLinkedinPost: `${URI_PREFIX}/linkedin/post/store`,
  linkedinPostsMediaType: `${URI_PREFIX}/linkedin/post/media/types`,
  linkedinCodeIDAutocomplete: `${URI_PREFIX}/linkedin/all/remote-id`,
  linkedinAllAutocomplete: `${URI_PREFIX}/linkedin/all`,
  linkedinInfluencersAutocomplete: `${URI_PREFIX}/linkedin/influencers`,
  linkedinIncompleteCodeIDAutocomplete: `${URI_PREFIX}/linkedin/incomplete/remote-id`,
  linkedinCommentsTab: `${URI_PREFIX}/linkedin/post/comments`,
  linkedinHashtagAutocompleteSentiment: `${URI_PREFIX}/linkedin/post/hashtags`,
  linkedinCommentsSorting: `${URI_PREFIX}/linkedin/post/comments/sorting`,
  linkedinUpdateSentimentAnalysis: `${URI_PREFIX}/linkedin/post/sentiment-analysis/data/update`,
  linkedinSetsAutocompleteSentiment: `${URI_PREFIX}/linkedin/sets`,
  linkedinMostFrequentHashtags: `${URI_PREFIX}/linkedin/post/sentiment-analysis/frequent-hashtags`,
  linkedinMostFrequentWords: `${URI_PREFIX}/linkedin/post/sentiment-analysis/frequent-words`,
  linkedinShowSentiment: `${URI_PREFIX}/linkedin/post/sentiment-analysis/data/show`,
  linkedinChangeCommentsCategories: `${URI_PREFIX}/linkedin/post/sentiment-analysis/comment/change-category`,
  linkedinSentimentAnalysisAdd: `${URI_PREFIX}/linkedin/post/sentiment-analysis/words/add`,

  //dashboard
  allPostsCount:`${URI_PREFIX}/dashboard/all/posts/count`,
  allTweetsCount:`${URI_PREFIX}/dashboard/twitter/posts/count`,
  allInstagramCount:`${URI_PREFIX}/dashboard/instagram/posts/count`,
  allLinkedinCount:`${URI_PREFIX}/dashboard/linkedin/posts/count`,
  allTiktokCount:`${URI_PREFIX}/dashboard/tiktok/posts/count`,
  allYoutubeCount:`${URI_PREFIX}/dashboard/youtuber/posts/count`,
  postsBreakdown:`${URI_PREFIX}/dashboard/platforms/posts/count`,
  trendingYoutube:'videos/dashboard/secondary/trending',
  trendingTiktok:`${URI_PREFIX}/dashboard/tiktok/top/trending`,
  trendingTiktokMap:`${URI_PREFIX}/dashboard/tiktok/trending/map`,
  trendingYoutubeMap:'videos/trending/map/by-coordinates'
};
